// The pitch the owner copies from a restaurant's admin page and sends by hand. Kept out of the view
// so a test can read it. It ends on the no-cost line while restaurants sign up at no cost.
import { brand } from './brand.ts';
import { RESTAURANT_NO_COST_LINE } from './no-cost-copy.ts';
import type { VenueDetail } from './venues.ts';

type PitchFacts = Pick<VenueDetail, 'name' | 'splits' | 'people' | 'perPersonCents' | 'groupsBack' | 'smsOptIns'>;

export function restaurantPitch(v: PitchFacts, money: (cents: number | null | undefined) => string): string {
  const n = (k: number, one: string, many: string) => `${k} ${k === 1 ? one : many}`;
  return `${v.name}: ${n(v.splits, 'group', 'groups')} split their bill here with ${brand.name}, ${n(v.people, 'guest', 'guests')}, about ${money(v.perPersonCents)} a person. ${v.groupsBack ? `${n(v.groupsBack, 'group', 'groups')} came back. ` : ''}${n(v.smsOptIns, 'guest', 'guests')} opted in, so the restaurant has their numbers for offers and updates. ${RESTAURANT_NO_COST_LINE}`;
}
